import { render, staticRenderFns } from "./LetterArguments.vue?vue&type=template&id=d8f66f60&scoped=true&"
import script from "./LetterArguments.vue?vue&type=script&lang=ts&"
export * from "./LetterArguments.vue?vue&type=script&lang=ts&"
import style0 from "./LetterArguments.vue?vue&type=style&index=0&id=d8f66f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f66f60",
  null
  
)

export default component.exports